<header>
    <h2>
        {{ 'mapping.base.tree.title.fullLabel' | translate }}
        <app-tooltip [text]="'mapping.base.tree.title.summary' | translate"></app-tooltip>
    </h2>
</header>

<form [formGroup]="filterForm"
      class="filter-form">
    <mat-form-field>
        <mat-label>{{ 'mapping.base.tree.filter.shortLabel' | translate }}</mat-label>
        <input matInput
               type="text"
               formControlName="filter">
    </mat-form-field>
</form>
<section class="tree">
    <app-tree-items [canEditMapping]="canEditMapping"
                    [treeItems]="tree"
                    [depsLabel]="depsLabel"
                    [isRoot]="true"
                    [displayValidity]="displayValidity"
                    (listChanged)="onTreeChanged($event)"></app-tree-items>
</section>